export const statusServicesService = async (name: string) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API}/onboarding-third-party/status?service=${name}`,
      {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      },
    )
    const data = await response.json()
    if (!response.ok && response) {
      throw new Error(
        data.error.message || '-- Ha ocurrido un error inesperado --',
      )
    }
    return data
  } catch (error) {
    throw error
  }
}
